export default __webpack_public_path__ + "static/media/retur-pembelian.dc46737a.png";